export default "__VITE_ASSET__BdMsLlRX__"